import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { Profession } from '../types/Profession';

export const listProfessions = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<Profession>> =>
  apiFetch('/professions?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listProfessionsAll = (sort?: string, query?: string): Promise<Profession[]> =>
  apiFetch('/professions/all' + (sort ? '?sort=' + sort : '') + (query ? (sort ? '&' : '?') + query : ''));
export const getProfession = (id: number): Promise<Profession> => apiFetch('/professions/' + id);
export const createProfession = (data: any): Promise<Profession> =>
  apiFetch('/professions', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateProfession = (id: number, data: any): Promise<Profession> =>
  apiFetch('/professions/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteProfession = (id: number): Promise<void> =>
  apiFetch('/professions/' + id, { method: 'DELETE' });
